export default "__VITE_ASSET__CYJP3Off__"